/**
 * Factory que retorna a função `cell` da coluna de ações de receita.
 * Recebe os callbacks de abrir os modais e retorna o renderer da célula.
 *
 * @param {Function} openApproveModal - Callback chamado ao clicar em "Registrar Pagamento"
 * @param {Function} openReproveModal - Callback chamado ao clicar em "Cancelar Receita"
 * @returns {Function} Função cell compatível com CustomList
 */
export const createRevenueActionsCell = (openApproveModal, openReproveModal) => (row) => (
    <div>
        {(row.status === 'pending' || row.status === 'partially_received' || row.status === 'overdue') && (
            <a
                className="btn btn-success btn-sm btn-action"
                style={{ marginRight: '5px', color: '#fff' }}
                onClick={() => openApproveModal(row)}
                title="Registrar Pagamento"
            >
                <i className="fas fa-check"></i>
            </a>
        )}
        {(row.status === 'pending' || row.status === 'overdue') && (
            <a
                className="btn btn-danger btn-sm btn-action"
                style={{ color: '#fff' }}
                onClick={() => openReproveModal(row)}
                title="Cancelar Receita"
            >
                <i className="fas fa-ban"></i>
            </a>
        )}
    </div>
);
